export const APP_NAME = 'VendoSphere';
export const COMPANY_NAME = '深圳市泓加亿网络科技有限公司';

export const STORAGE_KEYS = {
  CREDENTIALS: 'credentials',
  CLIENT_CREDENTIALS: 'client_credentials',
  ERP_USER_INFO: 'erpUserInfo',
  USER_INFO_CACHE: 'userInfoCache',
  LAST_SELECTED_USER: 'lastSelectedUser',
  LAST_SELECTED_VIEW: 'lastSelectedView',
  VIEW_USER_SELECTIONS: 'viewUserSelections',
};

export const EXPIRE_TIMES = {
  USER_CACHE: 8 * 60 * 60 * 1000, // 8小时
  TOKEN: 72 * 60 * 60 * 1000, // 72小时
  USER_SIG: 24 * 60 * 60 * 1000, // 24小时
};

export const CHANNEL_TYPE = {
  PRIVATE: 1, // 私域聊天
  MESSENGER: 2, // Facebook聊天
  WHATSAPP: 3, // WhatsApp
};

export const getChannelText = channel => {
  const map = {
    [CHANNEL_TYPE.PRIVATE]: '独立站',
    [CHANNEL_TYPE.MESSENGER]: 'Facebook',
    [CHANNEL_TYPE.WHATSAPP]: 'WhatsApp',
  };
  return map[channel] || '其他';
};

export const getChannelForShort = channel => {
  const map = {
    [CHANNEL_TYPE.PRIVATE]: '独立站',
    [CHANNEL_TYPE.MESSENGER]: 'fb',
    [CHANNEL_TYPE.WHATSAPP]: 'wa',
  };
  return map[channel] || '其他';
};

export const channelTextMap = {
  [CHANNEL_TYPE.PRIVATE]: '独立站',
  [CHANNEL_TYPE.MESSENGER]: 'Facebook',
  [CHANNEL_TYPE.WHATSAPP]: 'WhatsApp',
};

export const COMPARISON_OPERATORS = {
  eq: 'eq',
  neq: 'neq',
  gt: 'gt',
  ge: 'ge',
  lt: 'lt',
  le: 'le',
  in: 'in',
  notin: 'notin',
  like: 'like',
  notlike: 'notlike',
  isnull: 'isnull',
  notnull: 'isnotnull',
};

export const COMPARISON_OPERATOR_LABELS = {
  [COMPARISON_OPERATORS.eq]: '等于',
  [COMPARISON_OPERATORS.neq]: '不等于',
  [COMPARISON_OPERATORS.gt]: '大于',
  [COMPARISON_OPERATORS.ge]: '大于等于',
  [COMPARISON_OPERATORS.lt]: '小于',
  [COMPARISON_OPERATORS.le]: '小于等于',
  [COMPARISON_OPERATORS.in]: '包含',
  [COMPARISON_OPERATORS.notin]: '不包含',
  [COMPARISON_OPERATORS.like]: '模糊匹配',
  [COMPARISON_OPERATORS.notlike]: '不模糊匹配',
  [COMPARISON_OPERATORS.isnull]: '为空',
  [COMPARISON_OPERATORS.notnull]: '不为空',
};

export const AGGR_CHAT_USER = 'aggr_chat_user';

export const MOMENT_LOCALE_CONFIG = {
  months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
  monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
  weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
  weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
  weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'YYYY年MM月DD日',
    LLL: 'YYYY年MM月DD日 HH:mm',
    LLLL: 'YYYY年MM月DD日 dddd HH:mm',
  },
};

export const TIME_FORMAT = {
  DATE: 'YYYY年MM月DD日',
  DATETIME: 'YYYY年MM月DD日 HH:mm:ss',
};

export const CACHE_CONFIG = {
  TABLE_STRUCTURE_DURATION: 30 * 60 * 1000, // 30分钟
  TABLE_DATA_DURATION: 5 * 60 * 1000, // 5分钟
  DURATION: 5 * 60 * 1000, // 5分钟
  KEYS: {
    TABLE_CHAT_USER: 'table_chat_user',
    TABLE_LIST: 'table_list',
  },
};

export const IFRAME_MESSAGE_TYPES = {
  RESET_UNREAD_SUCCESS: 'RESET_UNREAD_SUCCESS',
  SWITCH_CONVERSATION_SUCCESS: 'SWITCH_CONVERSATION_SUCCESS',
};

export const DEFAULT_PAGE_SIZE = 20;
export const TIMMER_UPDATE_PAGE_SIZE = 15;

export const TIMER_INTERVALS = {
  VIRTUAL_SCROLL_REFRESH: 2000, // 2秒
  SERVICE_INCREMENTAL_UPDATE: 2000, // 2秒
  USER_LIST_TIMER: 10000, // 10秒
  VIRTUAL_SCROLL_TIMER: 2000, // 2秒
};

export const MESSAGE_CONFIG = {
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 20,
  DEFAULT_REQ_MSG_SEQ: 0,
};

export const CHAT_CONFIG = {
  SCROLL: {
    NEW_MESSAGE_THRESHOLD: 10000, // 10秒内认为是新消息
    SCROLL_DELAY: 100, // 滚动延迟
    TIMEOUT_DELAY: 200, // 超时延迟
  },
  INPUT: {
    MIN_ROWS: 1,
    MAX_ROWS: 4,
  },
};

export const SSE_CONFIG = {
  ROUTES: {
    MESSAGE: '/message',
  },
  RECONNECT: {
    MAX_ATTEMPTS: 5, // 增加最大重连次数
    INITIAL_DELAY: 2000, // 增加初始延迟到2秒
    RECONNECT_TIMEOUT: 100, // 重连延迟
    PAGE_REFRESH_DELAY: 500, // 进一步减少页面刷新延迟到0.5秒
  },
  USER_ID_KEYS: {
    LOCAL_STORAGE: ['userInfo', 'user', 'currentUser', 'authUser', 'loginUser'],
    SESSION_STORAGE: ['currentUserId', 'userId', 'user_id', 'uid', 'currentUser'],
    URL_PARAMS: ['userId', 'user_id', 'uid', 'id'],
    COOKIES: ['userId', 'user_id', 'uid', 'currentUserId'],
    GLOBAL_VARS: ['userId', 'currentUserId', 'user_id'],
  },
  CHAT_USER_ID_KEYS: {
    URL_PARAMS: ['chatUserId', 'chat_user_id'],
    LOCAL_STORAGE: ['currentChatUserId', 'selectedChatUserId'],
  },
};
